import type { GetPatientDetailsInclude } from '@montugroup/pms-api-contracts';

/*
  These form names correspond to the Patient Details endpoints keys. These are
  used to identify which part of the endpoint the form values need to be saved to
 */
export const PATIENT_DETAILS_FORM_NAMES: Record<string, GetPatientDetailsInclude> = {
  PATIENT_BASIC_INFO: 'patient-basic-info',
  PATIENT_IDENTIFICATION_INFO: 'patient-identification-info',
  PATIENT_MEDICAL_INFO: 'patient-medical-info',
  PATIENT_CARE_INFO: 'patient-care-info',
  PATIENT_RED_FLAG_INFO: 'patient-red-flag-info',
  PATIENT_EMERGENCY_CONTACT: 'patient-emergency-contact',
  PATIENT_CONTACT_DETAILS: 'patient-contact-details'
};

/* Select List options for "Aboriginal or Torres Strait Islander" drop down */
export const ATSI_LIST_OPTIONS = [
  'No',
  'Yes',
  'Yes, Aboriginal',
  'Yes, Torres Strait Islander',
  'Yes, both',
  'Prefer not to say'
];

export const DEFAULT_PAGE_SIZE = 5;
export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50];

export const PATIENT_TAB_IDS = {
  DETAILS: 'details',
  CONSULTATIONS: 'consultations',
  PRESCRIPTIONS: 'prescriptions',
  DOCUMENTATION: 'documentation',
  SCHEDULED_CONSULT: 'scheduledconsult'
} as const;

export const SCHEDULED_CONSULT_PARAM = 'scheduledConsult';
